export default __webpack_public_path__ + "static/media/typescript.29073194.png";